import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class AttachmentsService {

	constructor(private httpClient: HttpClient) {
	}

	getAttachmentFile(id: string) {
		return this.httpClient.get(`/api/attachments/${id}/file`, { observe: 'response', responseType: 'blob' });
	}

	removeAttachment(id: string) {
		return this.httpClient.delete<void>(`/api/attachments/${id}`);
	}
}